import { BodyZone, DeckDTO } from '@/generated';

export const filterBodyzones = (bodyZones: Array<BodyZone>, deck?: DeckDTO) => {
  return bodyZones.filter((bz) => bz.isDefaultZone);
};
